import React from 'react';
import { FiClipboard } from 'react-icons/fi';

const EmptyState = ({ message, description, icon = <FiClipboard aria-hidden="true" />, onRefresh }) => {
  return (
    <div className="empty-state">
      <div className="empty-icon">{icon}</div>
      <h3>{message || "No Tasks Found"}</h3>
      <p>{description || "There are no tasks matching your current filters."}</p>
      {onRefresh && (
        <button 
          className="refresh-button" 
          onClick={onRefresh}
          aria-label="Refresh tasks"
        >
          Refresh
        </button>
      )}
    </div>
  );
};

export default EmptyState; 